import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IBasket = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg width="24" height="24" viewBox="0 0 24 24"fill="none"  xmlns="http://www.w3.org/2000/svg" >
            <path fill={props.color??"#D34444"}   d="M6.99493 21C6.46302 21 6.00862 20.8118 5.63173 20.4353C5.25502 20.0586 5.06667 19.6044 5.06667 19.0728V5.54204H4V3.94294H8.8V3H15.2V3.94294H20V5.54204H18.9333V19.0728C18.9333 19.6114 18.7467 20.0672 18.3733 20.4403C18 20.8134 17.5439 21 17.0051 21H6.99493ZM17.3333 5.54204H6.66667V19.0728C6.66667 19.1686 6.69742 19.2472 6.75893 19.3087C6.82044 19.3702 6.89911 19.4009 6.99493 19.4009H17.0051C17.0872 19.4009 17.1624 19.3667 17.2307 19.2983C17.2991 19.2301 17.3333 19.1549 17.3333 19.0728V5.54204ZM9.23093 17.2688H10.8307V7.67417H9.23093V17.2688ZM13.1693 17.2688H14.7691V7.67417H13.1693V17.2688Z" />
          </svg>
        );
      }}
      
      {...props}
    />
  );
};

export default IBasket;
